<template>
  <el-scrollbar ref="app" id="app-scroll">
    <div
      v-loading.fullscreen.lock="
        globalStore.data.loading && globalStore.data.showLoading
      "
      element-loading-background="rgba(0, 0, 0, 0)"
      element-loading-text="...加载中..."
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      id="app"
    >
      <el-config-provider :locale="locale">
        <router-view />
      </el-config-provider>
    </div>
  </el-scrollbar>
</template>
<script>
import { ElConfigProvider } from "element-plus";
import zh from "element-plus/es/locale/lang/zh-cn";
import en from "element-plus/es/locale/lang/en";
import colorFasTrimStore from "@/views/main/colorTrim/index.js";
import colorFormTrimStore from "@/views/main/colorTrim/form.js";
import {
  provide,
  computed,
  defineComponent,
  ref,
  toRefs,
  onMounted,
  reactive,
  watch,
  getCurrentInstance,
  onBeforeUnmount,
  onUnmounted,
  onErrorCaptured,
} from "vue";
import userStore from "./store/user.js";
import globalStore from "./store/global.js";
import Cookie from "./utils/cache.js";
import { VxeUI } from "vxe-table";
import zhCN from "vxe-table/lib/locale/lang/zh-CN";
import esES from "vxe-table/lib/locale/lang/es-ES";
export default defineComponent({
  components: { [ElConfigProvider.name]: ElConfigProvider },
  setup() {
    window.addEventListener("storage", function (event) {
      if (event.key === "lang") {
        updatePageLanguage();
      }
    });
    let locale;
    const lang = localStorage.getItem("lang");
    switch (lang) {
      case "zh":
        locale = zh;
        break;
      case "en":
        locale = en;
        break;
      default:
        locale = zh;
    }
    const svg = `
        <path class="path" d="
          M 30 15
          L 28 17
          M 25.61 25.61
          A 15 15, 0, 0, 1, 15 30
          A 15 15, 0, 1, 1, 27.99 7.5
          L 15 15
        " style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"/>
      `;
    // const locale = zhcn;
    const { proxy } = getCurrentInstance();
    const handleClose = () => {
      proxy.$router.push("/user/login");
      userStore.data.vipDialog = false;
    };
    watch(
      () => globalStore.data.guideStep,
      (val) => {
        if (val === 10) {
          proxy.$refs.app.setScrollTop(
            document.getElementById("MetamerismTable").offsetTop - 200
          );
        }
        if (val === 11) {
          proxy.$refs.app.setScrollTop(
            document.getElementById("FastnessTable").offsetTop - 200
          );
        }
      }
    );
    onMounted(() => {
      VxeUI.setI18n("zh-CN", zhCN);
      VxeUI.setI18n("es-ES", esES);
      console.log(localStorage.getItem("lang"));
      if (localStorage.getItem("lang") === "en") {
        VxeUI.setLanguage("es-ES");
      } else {
        VxeUI.setLanguage("zh-CN");
      }
      const UseCommon = JSON.parse(sessionStorage.getItem("UseCommon"));
      document.documentElement.style.setProperty(
        "--sider-width",
        UseCommon?.siderWidth ?? "160px"
      );
      window.onbeforeunload = (e) => {
        // localStorage.removeItem("colorMatch");
        // localStorage.removeItem("qualityControl");
        colorFasTrimStore.init();
        colorFormTrimStore.init();
      };
    });
    onErrorCaptured((err) => {
      console.log("报错打印", err);
    });
    return { locale, userStore, handleClose, globalStore, svg };
  },
});
</script>
<style lang="scss" scoped>
:deep(.el-input__inner) {
  padding-left: 10px;
  &::placeholder {
    color: #a2a6b8;
    font-size: 14px;
  }
  
}
</style>
